module.exports = __webpack_public_path__ + "static/media/sell_resend_invoice_5.9735d259.jpg";